var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCrown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "39px",
    viewBox: "0 0 50 39",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WiP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-90.000000, -38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(90.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#808282",
    points: "3 14 25 26.5 47 14 40.855176 39 9.08421785 39"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fillOpacity: 0.262838724,
    fill: "#101A1A",
    points: "25 8 40 39 10 39"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5E6363",
    cx: 2,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5E6363",
    cx: 25,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5E6363",
    cx: 48,
    cy: 9,
    r: 2
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCrown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/crown.19ef7b17.svg";
export { ForwardRef as ReactComponent };